// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toaster_toast__2q_Ao"};